var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Card, CardBody, CardFooter, CardHeader, Content, ContentVariants, Flex, FlexItem } from '@patternfly/react-core';
import { HelperText } from '@patternfly/react-core/dist/dynamic/components/HelperText';
import { HelperTextItem } from '@patternfly/react-core/dist/dynamic/components/HelperText';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';
const useStyles = createUseStyles({
    fullHeightCard: {
        height: '100%'
    },
    image: {
        marginRight: 'var(--pf-t--global--spacer--md)',
        width: 48
    }
});
const ServiceCard = (_a) => {
    var { title, subtitle, description, icon, helperText, footer = null, ouiaId = 'ServiceCard', isStacked = false, isFullHeight = false } = _a, props = __rest(_a, ["title", "subtitle", "description", "icon", "helperText", "footer", "ouiaId", "isStacked", "isFullHeight"]);
    const classes = useStyles();
    return (React.createElement(Card, Object.assign({ className: clsx({ [classes.fullHeightCard]: isFullHeight }), ouiaId: `${ouiaId}-card` }, props),
        React.createElement(CardHeader, null,
            React.createElement(Flex, { direction: { default: isStacked ? 'column' : 'row' }, alignItems: { default: isStacked ? 'alignItemsFlexStart' : 'alignItemsCenter' } },
                React.createElement(FlexItem, { className: classes.image }, icon),
                React.createElement(FlexItem, null,
                    React.createElement(Content, null,
                        React.createElement(Content, { component: ContentVariants.h2, ouiaId: `${ouiaId}-title` }, title), subtitle !== null && subtitle !== void 0 ? subtitle : null)))),
        React.createElement(CardBody, { "data-ouia-component-id": `${ouiaId}-description` }, description),
        footer || helperText ? (React.createElement(CardFooter, { "data-ouia-component-id": `${ouiaId}-footer` },
            helperText ?
                (React.createElement(HelperText, { "data-ouia-component-id": `${ouiaId}-helper-text` },
                    React.createElement(HelperTextItem, { className: "pf-v6-u-mb-lg" }, helperText))) : null,
            footer)) : null));
};
export default ServiceCard;
